import { Component, OnInit, ViewEncapsulation, OnChanges } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { FormBuilder, Validators, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {Location} from '@angular/common';
// import { BreadCrumbService, } from './../../../ui-components'; //BreadCrumbModel
import { DropdownModel, StepIndicatorService, BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components';
import { UtilityService } from 'lib/ng2-sapmp/src/providers';
import { PageLoaderService } from 'lib/ng2-sapmp/src/ui-components/page-loader';
import { TransactionService } from '../shared/';
import { ENV } from 'config';
import { throwError } from 'rxjs';

export class FanStore {
  constructor(public id: number, public name: string) { }
}

@Component({
  selector: 'app-report-type',
  templateUrl: './report-type.component.html',
  styleUrls: ['./report-type.component.scss']
})
export class ReportTypeComponent implements OnInit {

  public pageJson: any;
  public fanLists: FanStore;
  public fanList: Array<any>;
  public allFans: Array<any>;
  public FanLists: Array<FanStore>;
  public reportForm: any;
  public showDropdown: boolean;
  public showError: boolean;
  public singleFanValue;
  public singleDeviceValue;
  private showTextBox: boolean;
  private FanDropDown;
  private wireless;
  private savedReportRequest: any;
  private selectedFan: string;
  private notShowAllFanRadioButton: string;
  public dontShowAllFanRadioButton: boolean;
  public showErrors: boolean;
  public errorMessage: any;
  constructor(private utilities: UtilityService,
    private breadcrumb: BreadCrumbService,
    private router: Router,
    private route: ActivatedRoute,
    private transactionService: TransactionService,
    private pageloaderService: PageLoaderService,
    public stepIndicator: StepIndicatorService, /*changed from private to public for testing purpose */
    private location: Location) {
    this.FanLists = [];
    this.dontShowAllFanRadioButton = false;
    this.showErrors = false;
    this.pageloaderService.setPageLoaderStatus(false);
  }

  ngOnInit() {
    document.title = this.utilities.getPageTitleConfig()[this.router.routerState.snapshot.url];
    this.stepIndicator.setCurrentStep(this.route.snapshot.url[0].path);
    this.stepIndicator.setVisibility(true);
    this.notShowAllFanRadioButton = sessionStorage.getItem('dontShowAllFanRadioButton');
    if (this.notShowAllFanRadioButton === 'true') {
      this.dontShowAllFanRadioButton = true;
     }   
    this.reportForm = new FormGroup({
      fan: new FormControl('', [<any>Validators.required]),
      fanDropDown: new FormControl(''),
      wireless: new FormControl('')
    });
    this.getAllFan();
    // this.transactionService.getReportPageConfig(this.utilities.getEnvConfig().getReportPageConfigUrl)
    //   .subscribe(respobj => {
        this.pageJson = this.route.snapshot.data.pageData.reportstransactionreportType;
        this.pageJson = this.pageJson['reportsreportType'];
        this.pageloaderService.setPageLoaderStatus(true);
      // }, error => {
      //   this.pageloaderService.setPageLoaderStatus(true);
      //   this.handleError(error);
      // });
    this.transactionService.createPageLoadProperties('REPORT_TYPE', 'reportType');

  }

  handleError = (error) => {
    return throwError(error);
  }

  next(ctnNumber?) {
    let selectedFan;
    let fan;
    this.savedReportRequest.accountType = this.reportForm.value.fan;
    if (this.savedReportRequest.accountType === 'allFan' || this.savedReportRequest.accountType === 'singleFan') {

      selectedFan = (this.savedReportRequest.accountType === 'allFan') ?
      { name: 'All accounts', value: 'allFan' } : this.reportForm.value.fanDropDown;

      this.savedReportRequest.selectedFan = selectedFan;
      this.savedReportRequest.selectedCtn = '';
      this.transactionService.setReportModel(this.savedReportRequest);
      this.router.navigate(['dateRange'], { relativeTo: this.route.parent });

    } else if (this.savedReportRequest.accountType === 'singleDevice') {
        this.pageloaderService.setPageLoaderStatus(false);
        this.transactionService.validateCTN(ctnNumber)
        .subscribe((respobj) => {
          if (respobj.errorMessage) {
            this.showErrors = true;
            this.errorMessage = respobj.errorMessage;
            this.pageloaderService.setPageLoaderStatus(true);
          } else {
            fan = respobj.fan;
            this.savedReportRequest.selectedFan = '';
            this.savedReportRequest.selectedCtn = { fan: fan, ctn: ctnNumber };
            this.transactionService.setReportModel(this.savedReportRequest);
            this.pageloaderService.setPageLoaderStatus(true);
            this.router.navigate(['dateRange'], { relativeTo: this.route.parent });
          }
        }, (error) => {
          this.pageloaderService.setPageLoaderStatus(true);
          this.handleError(error);
        });
    }
  }

  cancel() {
    this.breadcrumb.removeLastBreadCrumb();
    const currentUrl = this.breadcrumb.getLastUrlFromBreadCrumb().routerLink;
    this.router.navigate([currentUrl]);
  }


  getAllFan() {
    this.savedReportRequest = this.transactionService.getReportModel();  
    if (!this.savedReportRequest.fanList.length && sessionStorage.getItem('FanLists')) {
      const FanLists = sessionStorage.getItem('FanLists');
      this.FanLists = JSON.parse(FanLists);   
      this.savedReportRequest.fanList = this.FanLists;
      this.transactionService.setReportModel(this.savedReportRequest);
      this.createFanSelectOption();
    } else {
      this.createFanSelectOption();
    }

  }

  createFanSelectOption() {
    this.fanList = new Array();
    const selectedFan = this.savedReportRequest.selectedFan;
    const accountType = this.savedReportRequest.accountType;
    if (selectedFan && accountType === 'singleFan') {
      this.selectedFan = this.showDropdown ? this.createDropDownOptions(selectedFan.name, selectedFan.value) : selectedFan;
    }
    this.savedReportRequest.fanList.filter(fan => {
      this.fanList.push(this.createDropDownOptions(fan.name, fan.id));
    });
    this.setOptionValue(accountType);

    // Change the form controls too
    if (this.reportForm.controls['fanDropDown']) {
      this.reportForm.controls['fanDropDown'].setValue(this.selectedFan);
    }
    this.reportForm.controls['fan'].setValue(accountType);
  }
  updateDeviceTextbox() {
    const selectedCtn = this.savedReportRequest.selectedCtn.ctn;
    this.reportForm.controls['wireless'].setValue(this.formatCtn(selectedCtn));
  }
  onInput($event) {
    $event.preventDefault();
  }

  createDropDownOptions(name, value): DropdownModel {
    const dropDown = {
      'name': name,
      'value': value
    };
    return dropDown;
  }

  setOptionValue(option) {
      if (option === 'singleFan') {
        this.showDropdown = true;
        this.showTextBox = false;
        /*update the validator based on selection*/
        this.reportForm.controls['fanDropDown'].validator = Validators.required;
        this.reportForm.controls['wireless'].validator = Validators.nullValidator;
      } else if (option === 'singleDevice') {
        this.showDropdown = false;
        this.showTextBox = true;
        this.reportForm.controls['wireless'].validator = Validators.required;
        this.reportForm.controls['fanDropDown'].validator = Validators.nullValidator;
        this.updateDeviceTextbox();
  
      } else {
        this.showDropdown = false;
        this.showTextBox = false;
        this.reportForm.controls['wireless'].validator = Validators.nullValidator;
        this.reportForm.controls['fanDropDown'].validator = Validators.nullValidator;
      }
      this.reportForm.controls['fanDropDown'].updateValueAndValidity();
      this.reportForm.controls['wireless'].updateValueAndValidity();  
  }
  onChange(event) {

    let ctnstr = event.replace(/[\.]/g, '');
    ctnstr = ctnstr.replace(/[' ']/g, '');

    if(ctnstr.length !== 10 && Number.isInteger(Number(ctnstr))) {
      this.showError = true;
    }
    if (this.showError === true && ctnstr.length === 10 &&  Number.isInteger(Number(ctnstr))) {
      this.showError = false;
    }
  }

  /*to format the numbers to phone number*/
  formatCtn(tel) {
    const value = tel.toString().trim().replace(/^\+/, '');

    if (value.match(/[^0-9]/)) {
      return tel;
    }
    let city, number;
    switch (value.length) {
      case 1:
      case 2:
      case 3:
        city = value;
        break;

      default:
        city = value.slice(0, 3);
        number = value.slice(3);
    }
    if (number) {
      if (number.length > 3) {
        number = number.slice(0, 3) + '.' + number.slice(3, 7);
      } else {
        number = number;
      }
      return (+ city + '.' + number).trim();
    } else {
      return city;
    }
  }
}
